import { FIELD_TYPES } from '../../components/FormField'

export const FIELDS = [
  { label: 'Name', name: 'name', type: FIELD_TYPES.TEXT, defaultValue: '' },
  { label: 'Code', name: 'code', type: FIELD_TYPES.TEXT, defaultValue: '' },
  {
    label: 'Division',
    name: 'divisionId',
    type: FIELD_TYPES.SELECT,
    options: [
      { label: 'Law', value: 1 },
      { label: 'Fire', value: 2 },
      { label: 'EMS', value: 3 },
    ],
  },
]
